export default __webpack_public_path__ + "static/media/westbroekp1.6c34b96c.jpg";